import type { InviteMembersModalAction } from '#actions/inviteMembersModal';
import type { InviteMembersModalProps } from '#components/inviteMembers/InviteMembersModal';
import registry from '#reducers/registry';
import type { GlobalState } from '#reducers/state';

type InviteMembersModalState = {
  showModal: boolean;
  props: InviteMembersModalProps;
};

export const initialState: InviteMembersModalState = {
  showModal: false,
  props: { referrer: '' },
};

export function inviteMembersModal(state: InviteMembersModalState = initialState, action: InviteMembersModalAction) {
  switch (action.type) {
    case 'inviteMembersModal/OPEN_MODAL':
      return { ...state, showModal: true, props: action.props };
    case 'inviteMembersModal/CLOSE_MODAL':
      return { ...state, showModal: false, props: { referrer: '' } };
    default:
      return state;
  }
}

export const inviteMembersModalSelector = (state: GlobalState) => state.inviteMembersModal;

registry.addReducers({ inviteMembersModal });

declare module '#reducers/state' {
  interface GlobalState {
    inviteMembersModal: ReturnType<typeof inviteMembersModal>;
  }
}
